import React, { useEffect, useRef, useState } from "react";
import "../dashboard/styleDashboard.scss";
import "moment/locale/pt";
import { useGeneralContext } from "../General/Context";
import { ConfigSettings } from "../../config/Config";
import moment from "moment";
import { DashboardService } from "../../services/DashboardService";
import Iframe from "../../components/Iframe";
import { useHistory } from "react-router";
import { iframeService } from "../../services/iFrameService";

const settings = ConfigSettings();

const Dashboard = () => {
  const { userInformation } = useGeneralContext();
  const [dashboardUrl, setDashboardUrl] = useState();
  let parameters = useRef({
    minimalRating: 5,
    numberOfDays: 60
  });

  useEffect(() => {
    DashboardService.getDashboardParameters().then((data) => {
      parameters.current = data;
    });
  }, []);

  let history = useHistory();

  function goToInterviewsCurrentWeek() {
    let today = new Date();

    let startOfWeek = new Date();
    startOfWeek.setDate(startOfWeek.getDate() - today.getDay() + 1);
    today.setDate(today.getDate() + 1);
    history.push(
      `/interview/10/1?startingDate=${formatDate(
        startOfWeek
      )}&endingDate=${formatDate(today)}`
    );
  }

  function goTointerviewsLastWeek() {
    let today = new Date();
    let endOfLastweek = new Date();
    endOfLastweek.setDate(endOfLastweek.getDate() - today.getDay());
    let startOfLastweek = new Date();
    startOfLastweek.setDate(endOfLastweek.getDate() - 6);
    today.setDate(today.getDate() + 1);
    history.push(
      `/interview/10/1?startingDate=${formatDate(
        startOfLastweek
      )}&endingDate=${formatDate(endOfLastweek)}`
    );
  }

  function goToInterviewsThisMonth() {
    let today = new Date();
    let startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    today.setDate(today.getDate() + 1);
    history.push(
      `/interview/10/1?startingDate=${formatDate(
        startOfMonth
      )}&endingDate=${formatDate(today)}`
    );
  }

  function goToInterviewTopCandidates() {
    let startfromDate = new Date();
    startfromDate.setDate(
      startfromDate.getDate() - parameters.current.numberOfDays
    );
    history.push(
      `/interview/10/1?startingDate=${formatDate(startfromDate)}&rating=${
        parameters.current.minimalRating
      }`
    );
  }

  function goToInterviewRecomended() {
    let startfromDate = new Date();
    startfromDate.setDate(
      startfromDate.getDate() - parameters.current.numberOfDays
    );
    history.push(`/interview/10/1?recommended=true`);
  }

  function goToPreCandidates() {
    history.push(`/precandidate`);
  }

  function openPrecandidateDetails(event) {
    history.push(`/precandidate?precandidateId=${event.data.args[0]}`);
  }

  function ClickDocOnline() {
    history.push(`/InterviewDocPage`);
  }

  function openInterviewDetails(event) {
    history.push(`/interview/view/${event.data.args[0]}`);
  }

  function opendocOnlineIterview(event) {
    DashboardService.getDetailsUrls(event.data.args[0]).then((data) => {
      if (data.hasInterview) history.push(`interview/view/${data.interviewId}`);
      else history.push(`/precandidate?precandidateId=${event.data.args[0]}`);
    });
  }

  function opendInterviewDetailsByEmail(event) {
    DashboardService.getInterviewIdByEmail(event.data.args[0]).then((data) => {
      history.push(`/interview/view/${data.interviewId}`);
    });
  }

  function openReApplications() {
    history.push(`/interview/reApplications`);
  }

  function openProposals() {
    history.push(`/preproposals?status=sent`);
  }

  const messagehandllers = {
    origin: settings.outSystemBaseUrl,
    precandidate: goToPreCandidates,
    interview_this_month: goToInterviewsThisMonth,
    interview_top_candidate: goToInterviewTopCandidates,
    interview_last_week: goTointerviewsLastWeek,
    interview_current_week: goToInterviewsCurrentWeek,
    interview_doconline: ClickDocOnline,
    interview_recommended: goToInterviewRecomended,
    precandidate_detail: openPrecandidateDetails,
    interview_detail: openInterviewDetails,
    open_docOnline_iterview: opendocOnlineIterview,
    interview_details_by_email: opendInterviewDetailsByEmail,
    interview_proposals: openProposals,
    reApplications: openReApplications
  };

  function formatDate(date) {
    return moment(date).format("YYYY-MM-DD hh:mm");
  }

  //a espera de update do lado do outsystem
  function createIframeUrl() {
    iframeService
      .getDashBoard()
      .then((data) =>
        setDashboardUrl(
          `${
            settings.outSystemBaseUrl
          }/Rec_Shared/Dashboard_v3?k=${encodeURIComponent(data.key)}`
        )
      );
  }

  useEffect(() => {
    // if (userInformation.email) createIframeUrl();
  }, [userInformation]);

  return (
    <>
      {/*{dashboardUrl && (
        <Iframe
          url={dashboardUrl}
          title="dashboard"
          messagehandllers={messagehandllers}
        />
      )}*/}
      <div className="dashboard-under-construction">
        <div className="dashboard-under-construction__icon">🏗️</div>

        <h2>Novo Dashboard está em construção.</h2>

        <p>Pedimos desculpas pelos transtornos. Em breve teremos novidades.</p>

        <div className="dashboard-under-construction__english">
          <h3>New Dashboard is under construction.</h3>

          <p>
            We apologize for the inconvenience. We will have exciting news for
            you soon.
          </p>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
